import { SET_DATA, RESET_DATA, GET_DATA } from 'modules/MediaPlanner/store/types'

export const actionGetData = (props) => ({
  type: GET_DATA,
  payload: props,
})

export const actionSetData = (props) => ({
  type: SET_DATA,
  payload: props,
})

export const actionResetData = (props) => ({
  type: RESET_DATA,
  payload: props,
})
